import { useState } from "react";
import GridView from "../../components/controls/GridView/GridView";
import { Report } from "../../models/interfaces";
import reportService from "../../services/reportService";
import Frame from "../../components/controls/Frame/Frame";
import FormCommand from "../../components/controls/FormCommand";
import TextBox from "../../components/controls/TextBox/TextBox";
import FormModal from "../../components/controls/FormModal";

export interface ReportListingPageProps {}

function ReportListingPage(props: ReportListingPageProps) {
  const [reports, setReports] = useState<Report[]>([]);
  const [report, setReport] = useState<Report>();

  const menuItems = [
    {
      name: "Edit Report",
      contextName: "report",
      onClick: (report) => {
        //navigate("builder/" + report.id.toString());
      },
    },
    {
      name: "Delete report",
      contextName: "report",
      onClick: (report) => {
        const ans = window.confirm(
          "Are you sure you want to delete this report"
        );
        if (ans === true) {
          const deleteReport = async () => {
            const resp = await reportService.deleteReport(report.id);
            if (resp.status) {
              setReports(reports.filter((d) => d.id !== report.id));
              alert("Report deleted");
            }
          };

          deleteReport();
        }
      },
    },
    {
      name: "Add report items",
      contextName: "Reports",
      onClick: (report) => {
        //navigate(`../report/${report.id}/items`);
      },
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col">
          <Frame>
            <GridView<Report>
              showAddButton={true}
              name="lstReports"
              rowsPerPage={50}
              showSearchBar={true}
              onAddRecord={() => setReport({})}
            />
          </Frame>
        </div>
      </div>

      {report && (
        <FormModal onClose={() => setReport(undefined)}>
          <ReportBuilderForm />
        </FormModal>
      )}
    </>
  );
}

export default ReportListingPage;

export interface ReportBuilderFormProps {}

export function ReportBuilderForm(props: ReportBuilderFormProps) {
  return (
    <div className="row">
      <div className="col">
        <TextBox
          id="reportName"
          placeHolder="Enter name of the report"
          text="Report Name"
          maxValue={8}
        />
        <TextBox
          id="reportColumns"
          type="number"
          placeHolder="Specify the number of columns"
          text="Report Name"
          minValue={1}
          maxValue={7}
        />

        <FormCommand />
      </div>
    </div>
  );
}
